module.exports = __webpack_public_path__ + "media/images/no_image-75b22e7aae72b1f8a094136b3375d3ef.svg";